module.exports = __webpack_public_path__ + "static/media/IR.5c277320.png";